import React from "react";

/* ------------------------------------------------------------------
   Docs — Softdata
   ------------------------------------------------------------------ */

export default function SoftdataDocs() {
  return (
    <main className="docs-wrap">
      <div className="docs-layout">
        {/* TOC */}
        <aside className="docs-toc">
          <strong>On this page</strong>
          <a href="#intro">Introduction</a>
          <a href="#install">Install</a>
          <a href="#usage">Usage</a>
          <a href="#features">Features</a>
          <a href="#examples">Examples</a>
        </aside>

        {/* Content */}
        <article>
          <header className="stt-hero">
            <div className="stt-pill">softdata • Docs</div>
            <h1 className="stt-h1">Tidy data utilities</h1>
            <p className="stt-lead">
              Helpers for cleaning, encoding, splitting, and reporting. Make
              preprocessing <em>consistent and fast</em>.
            </p>
          </header>

          <section id="intro" className="stt-section">
            <h2 className="stt-h2">What is softdata?</h2>
            <p className="stt-p">
              A lightweight library for students and teams. It standardizes
              preprocessing — from missing value imputation to one-hot encoding
              and train/test splits — so you can focus on the model.
            </p>
          </section>

          <section id="install" className="stt-section">
            <h2 className="stt-h2">Installation</h2>
            <div className="stt-code">
              <pre className="stt-pre">pip install softdata</pre>
            </div>
          </section>

          <section id="usage" className="stt-section">
            <h2 className="stt-h2">Basic Usage</h2>
            <div className="stt-code">
              <pre className="stt-pre">{`from softdata import clean, encode, split

df = clean(df)             # handle NaNs
df = encode(df)            # label/one-hot
train, test = split(df)    # train/test split`}</pre>
            </div>
          </section>

          <section id="features" className="stt-section">
            <h2 className="stt-h2">Key Features</h2>
            <ul className="stt-list">
              <li><strong>Imputation:</strong> mean/median/mode strategies</li>
              <li><strong>Encoding:</strong> label & one-hot</li>
              <li><strong>Splitting:</strong> stratified train/test splits</li>
              <li><strong>Reporting:</strong> quick data summaries</li>
            </ul>
          </section>

          <section id="examples" className="stt-section">
            <h2 className="stt-h2">Examples</h2>
            <p className="stt-p">
              See <a href="/examples/softdata" className="stt-link">examples</a>{" "}
              for sample workflows.
            </p>
          </section>
        </article>
      </div>
    </main>
  );
}
